import { createFileRoute, useParams } from "@tanstack/react-router";
import { CustomerGalleryPage } from "@/features/gallery-public/CustomerGalleryPage";

export const Route = createFileRoute("/booking/me_/orders/$orderId/gallery")({
  component: BookingGalleryRoute,
});

function BookingGalleryRoute() {
  const { orderId } = useParams({ from: "/booking/me_/orders/$orderId/gallery" });
  return <CustomerGalleryPage scope={{ kind: "portal", orderId }} />;
}
